// settings.js
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '@/config/firebase';

export class Settings {
  constructor(userId) {
    this.userId = userId;

    this.defaults = {
      sensitivity: 20,
      invertMouse: false,
      play_sound: true, // Added default sound setting
      volume: 0.5 // Added default volume (0.0 to 1.0 is common for audio)
    };
    this.values = { ...this.defaults };
  }

  async load() {
    if (!this.userId) return this.values; // Return defaults if no userId

    try {
      const docRef = doc(db, 'userSettings', this.userId);
      const snapshot = await getDoc(docRef);
      if (snapshot.exists()) {
        const data = snapshot.data();
        this.values = {
          sensitivity: data.sensitivity !== undefined ? data.sensitivity : this.defaults.sensitivity,
          invertMouse: data.invertMouse !== undefined ? data.invertMouse : this.defaults.invertMouse,
          play_sound: data.play_sound !== undefined ? data.play_sound : this.defaults.play_sound, // Load sound setting
          volume: data.volume !== undefined ? data.volume : this.defaults.volume // Load volume setting
        };
      }
      //  console.log('[Settings] Loaded:', this.values);
      return this.values;
    } catch (error) {
      console.error('[Settings] Failed to load... reverting to defaults: ', error);
      this.values = { ...this.defaults }; // Ensure defaults are set on error
      return this.values;
    }
  }

  async save(newValues) {
    if (!this.userId) {
        console.warn('[Settings] Cannot save settings without a userId.');
        return;
    }

    try {
      // Only save the keys defined in defaults to avoid saving unexpected data
      const dataToSave = {};
      for (const key in this.defaults) {
          if (newValues.hasOwnProperty(key)) {
              dataToSave[key] = newValues[key];
          } else if (this.values.hasOwnProperty(key)) {
               // If not in newValues, use the current value from this.values
               dataToSave[key] = this.values[key];
          }
      }


      await setDoc(doc(db, 'userSettings', this.userId), dataToSave, { merge: true }); // Use merge: true
      // console.log('[Settings] Saved:', dataToSave);
      // It's good practice to update this.values after a successful save if newValues was a partial update
      this.values = { ...this.values, ...dataToSave };

    } catch (error) {
      console.error('[Settings] Failed to save:', error);
    }
  }
   // Add a getter for current values if needed externally
   getValues() {
       return this.values;
   }
}